<template>
  <div class="d-flex">
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0098 0H2.00977C0.909766 0 0.00976562 0.9 0.00976562 2V16C0.00976562 17.1 0.909766 18 2.00977 18H16.0098C17.1098 18 18.0098 17.1 18.0098 16V2C18.0098 0.9 17.1098 0 16.0098 0ZM12.0098 7.5C12.0098 8.33 11.3398 9 10.5098 9C11.3398 9 12.0098 9.67 12.0098 10.5V12C12.0098 13.11 11.1098 14 10.0098 14H6.00977V12H10.0098V10H8.00977V8H10.0098V6H6.00977V4H10.0098C11.1098 4 12.0098 4.89 12.0098 6V7.5Z"
        fill="#FF266E"
      />
    </svg>
    <svg
      class="ms-2"
      width="19"
      height="18"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z"
        fill="#FF266E"
      />
    </svg>
  </div>
</template>
